/**
 * This file contains the event types that are used in the application.
 * The values represent the event types as we want them named and analyzed on our analytics platforms.
 */
export const eventTypes = {
  portfolioCreationStarted: 'portfolio_creation_started',
  portfolioCreated: 'portfolio_created',
  portfolioCreationFailed: 'portfolio_creation_failed',
  // GTM specific events
  pageView: 'page_view',
  userIdentify: 'user_identify',
  scroll: 'scroll',
  portfolioCreation: 'portfolio_creation',
  transactionCompleted: 'transaction_completed',
  search: 'search',
  clickSearchBar: 'click_search_bar',
  clickMenuPrincipal: 'click_menu_principal',
  toggleMenuBurger: 'toggle_menu_burger',
  clickViewFeed: 'click_view_feed',
  createPost: 'create_post',
  followActive: 'follow_active',
  followInvestor: 'follow_investor',
  sendMessageInvestor: 'send_message_investor',
  clickAlert: 'click_alert',
  clickTopPortfolios: 'click_top_portfolios',
  interactionArticle: 'interaction_article',
  postImpression: 'post_impression',
  portfolioInteraction: 'portfolio_interaction',
  interaction: 'interaction',
  onboarding: 'onboarding',
  login: 'login',
  register: 'sign_up',
};
